import PhoneInput from 'react-phone-input-2';
import styled from 'styled-components/macro';
import { deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const FormMainWrapper = styled.div`
  width: 100%;
`;

export const StyledFlexContainer = styled.div`
  ${FLEX_CONTAINER.FlexColumn}
  margin: 30px 0px;
  height: 20px;
  width: 45%;
  align-items: flex-start;

  @media only screen and ${deviceMax.tablet} {
    width: 100%;
  }
`;

export const StyledErrorMessage = styled.div`
  ${FONTS.font12}
  color: ${COLORS.red};
`;

export const QuoteBlock = styled.span`
  ${FONT_FAMILY.FontMedium}
  ${FONTS.font20}
  color: ${COLORS.mainColor};

  @media only screen and ${deviceMax.desktop} {
    ${FONTS.font16}
  }

  @media only screen and ${deviceMax.laptopLMax} {
    ${FONTS.font14}
  }
`;

export const Form = styled.form`
  width: 100%;
  margin-top: 20px;
`;

export const UserInformationContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  width: 100%;
  flex-wrap: wrap;
`;

export const InfoFromUserInput = styled.input`
  width: 100%;
  height: 20px;
  border: none;
  outline: none;
  background: none;
  border-bottom: 1px solid ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
  color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};

  ${FONTS.font16}

  ::placeholder {
    color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
    ${FONTS.font16}
  }

  @media only screen and ${deviceMax.tablet} {
    width: 100%;
  }

  @media only screen and ${deviceMax.mobileL} {
    ::placeholder {
      ${FONTS.font14}
    }
  }
`;

export const PhoneFromUserInput = styled(PhoneInput)`
  width: 100%;
  height: 20px;
  border: none;
  outline: none;
  border-bottom: 1px solid ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
  line-height: 18px;

  input{
  ::placeholder{
    color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
  }
}

  * {
    ${FONTS.font16}
    color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
  }

  .country-name {
    color:${COLORS.mainColor};
  }

  .selected-flag {
    background: none !important;
  }

  @media only screen and ${deviceMax.mobileL} {
    * {
      ${FONTS.font16}
    }
  }
`;

export const UserMessageContainer = styled.div``;

export const MessageInput = styled.input`
  width: 100%;
  height: 20px;
  border: none;
  outline: none;
  background: none;
  border-bottom: 1px solid ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
  color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
  margin-top: 30px;
  ${FONTS.font16}

  ::placeholder {
    color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
    ${FONTS.font16}
  }

  @media only screen and ${deviceMax.tablet} {
    margin-top: 20px;
  }

  @media only screen and ${deviceMax.laptopLMax} {
    width: 100%;
  }

  @media only screen and ${deviceMax.mobileL} {
    ::placeholder {
      ${FONTS.font14}
    }
  }
`;

export const ButtonBlock = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow}
  margin-top: 30px;
  width: 100%;

  @media only screen and ${deviceMax.laptopLMax} {
    ${FLEX_CONTAINER.FlexCenterRow}
  }
`;
